$('.modal--video').on('show.bs.modal', (e) => {
    const videoIframe = e.target.querySelector('[data-src]');
    const videoContainer = videoIframe.parentElement;

    videoIframe.remove();
    videoIframe.setAttribute('src', videoIframe.dataset.src);
    videoContainer.appendChild(videoIframe);
});

$('.modal--video').on('hidden.bs.modal', (e) => {
    const videoIframe = e.target.querySelector('[data-src]');
    const videoContainer = videoIframe.parentElement;

    videoIframe.remove();
    videoIframe.removeAttribute('src');
    videoContainer.appendChild(videoIframe);
});
